import { useEffect, useState } from "react";
import { CONSENT_KEY, getConsent, initConsentMode, saveConsent } from "@/lib/consent";
import { captureAttribution } from "@/lib/utm-capture";

export function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    initConsentMode();
    captureAttribution();
    if (!getConsent()) setOpen(true);
    const handler = () => setOpen(true);
    window.addEventListener("open-cookie-banner", handler);
    return () => window.removeEventListener("open-cookie-banner", handler);
  }, []);

  function decide(analytics: "granted" | "denied", ads: "granted" | "denied") {
    saveConsent({ analytics, ads, decided_at: new Date().toISOString() });
    setOpen(false);
  }

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
      aria-live="polite"
      className="fixed bottom-0 inset-x-0 z-[100] bg-white dark:bg-[var(--color-surface-container-high)] border-t border-[var(--color-outline-variant)] shadow-2xl"
    >
      <h2 id="cookie-banner-title" className="sr-only">Aviso de cookies</h2>
      <div className="max-w-container-max mx-auto px-4 sm:px-margin-desktop py-4 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <p id="cookie-banner-desc" className="text-sm text-[var(--color-on-surface-variant)] max-w-3xl">
          <span aria-hidden="true">🍪 </span>Usamos cookies propias y de terceros para mejorar tu experiencia y analizar el tráfico. Puedes aceptar todas,
          rechazarlas o revisar nuestra política. Cumple con la Ley 21.719 (CL) y GDPR.{" "}
          <a href="/legal/cookies" className="underline text-[var(--color-brand-purple)]">Política de cookies</a>
        </p>
        <div className="flex flex-wrap gap-2 shrink-0 w-full md:w-auto" role="group" aria-label="Preferencias de cookies">
          <button
            type="button"
            onClick={() => decide("denied", "denied")}
            className="flex-1 md:flex-none px-4 py-2 border border-[var(--color-outline-variant)] text-sm font-semibold hover:bg-[var(--color-surface-container-low)] rounded"
          >
            Rechazar
          </button>
          <button
            type="button"
            onClick={() => decide("granted", "denied")}
            className="flex-1 md:flex-none px-4 py-2 border border-[var(--color-brand-purple)] text-[var(--color-brand-purple)] text-sm font-semibold hover:bg-[var(--color-surface-container-low)] rounded"
          >
            Solo analítica
          </button>
          <button
            type="button"
            onClick={() => decide("granted", "granted")}
            className="flex-1 md:flex-none px-4 py-2 bg-[var(--color-brand-coral)] text-white text-sm font-bold uppercase tracking-wider hover:brightness-110 rounded"
          >
            Aceptar todo
          </button>
        </div>
      </div>
    </div>
  );
}


export { CONSENT_KEY };
